module.exports = __webpack_public_path__ + "static/media/logo.f65bb33d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 496
// module chunks = 0